import React from "react";
import AdminNotification from "../../../components/Notification/AdminNotification";
import CertificatesApprovalsTable from "../../../components/CertificatesApprovalsTable/CertificatesApprovalsTable";

const CertificateRequests = () => {
  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3">
            Certificate Requests
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <AdminNotification />
          </div>
        </div>
      </div>
      <div>
        <CertificatesApprovalsTable />
      </div>
    </>
  );
};

export default CertificateRequests;
